import { render, staticRenderFns } from "./UiPageSelector.vue?vue&type=template&id=a523b862&scoped=true"
import script from "./UiPageSelector.vue?vue&type=script&lang=js"
export * from "./UiPageSelector.vue?vue&type=script&lang=js"
import style0 from "./UiPageSelector.vue?vue&type=style&index=0&id=a523b862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a523b862",
  null
  
)

export default component.exports